import React from "react";
import {withTranslation} from "react-i18next";
import stylesWelcome from "../SchedaSpecialeMalaria.module.css"
import Calendar from "../../../../../../../components/calendar/Calendar";
import Utils from "../../../../../../../utils/Utils";
import Input from "../../../../../../../components/textbox/Input";
import OggettiUtili from "../../../../../../../utils/OggettiUtili.json"

class DatiSanitariMalaria extends React.Component {

    state = {
        datiSanitari: {
            dataSintomi: "",
            dataRicovero: "",
            struttura: "",
            reparto: "",
            dataDiagnosi: "",
            dataEmoscopica: "",
            corretto: []
        },
        listaStrutture: JSON.parse(sessionStorage.getItem("struttureAndStabilimentiPerCodice")),
        listaRepartiPerCodice: JSON.parse(sessionStorage.getItem("repartiPerCodice"))

    }

    constructor(props) {
        super(props)

        this.riceviValore = this.riceviValore.bind(this);
        this.controlloDati = this.controlloDati.bind(this);
        this.createOggettoBE = this.createOggettoBE.bind(this)
        this.validate = this.validate.bind(this);
    }

    componentDidMount() {
        let datiSanitari = this.state.datiSanitari

        if (this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.datiSanitariMalaria) {

            let datiSanitariProps = this.props.segnalazioneCopia.schedaSpeciale.datiSanitariMalaria

            datiSanitari.dataSintomi = datiSanitariProps.dataSintomi ? datiSanitariProps.dataSintomi : this.state.datiSanitari.dataSintomi
            datiSanitari.dataRicovero = datiSanitariProps.dataRicovero ? datiSanitariProps.dataRicovero : this.state.datiSanitari.dataRicovero
            datiSanitari.struttura = datiSanitariProps.struttura ? datiSanitariProps.struttura : this.state.datiSanitari.struttura
            datiSanitari.reparto = datiSanitariProps.reparto ? datiSanitariProps.reparto : this.state.datiSanitari.reparto
            datiSanitari.dataDiagnosi = datiSanitariProps.dataDiagnosi ? datiSanitariProps.dataDiagnosi : this.state.datiSanitari.dataDiagnosi
            datiSanitari.dataEmoscopica = datiSanitariProps.dataEmoscopica ? datiSanitariProps.dataEmoscopica : this.state.datiSanitari.dataEmoscopica

            this.setState({datiSanitari: datiSanitari});
            this.controlloDati()
            let oggetto = this.createOggettoBE()
            this.props.setDatiSanitariMalaria(this.state.datiSanitari, "", oggetto)
        } else if (this.props.segnalazioneCopia.datiSanitari) {

            let datiAnagraficiProps = this.props.segnalazioneCopia.datiSanitari

            datiSanitari.dataSintomi = datiAnagraficiProps.dataInizioSintomi ? Utils.transformDateForFrontend(datiAnagraficiProps.dataInizioSintomi) : ""
            datiSanitari.dataRicovero = datiAnagraficiProps.dataRicovero ? Utils.transformDateForFrontend(datiAnagraficiProps.dataRicovero) : ""
            datiSanitari.struttura = datiAnagraficiProps.struttura && this.state.listaStrutture[(datiAnagraficiProps.struttura)] ? this.state.listaStrutture[(datiAnagraficiProps.struttura)].descrizione :
                datiAnagraficiProps.strutturaExtra && this.state.listaStrutture[(datiAnagraficiProps.strutturaExtra)] ? this.state.listaStrutture[(datiAnagraficiProps.strutturaExtra)].descrizione : ""
            datiSanitari.reparto = datiAnagraficiProps.reparto ? this.state.listaRepartiPerCodice[datiAnagraficiProps.reparto].descrizione : ""

            this.setState({datiSanitari: datiSanitari});

        }
        this.controlloDati()
        let oggetto = this.createOggettoBE()
        this.props.setDatiSanitariMalaria(this.state.datiSanitari, "", oggetto)

    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState !== this.state) {
            let res = this.createOggettoBE()
            this.props.setDatiSanitariMalaria(this.state.datiSanitari, this.validate(), res)
        }
    }

    validate() {

        if (this.state.datiSanitari.dataSintomi) {
            let validatedataSintomi = Utils.checkDateInterval(this.state.datiSanitari.dataSintomi, "31/12/1899");
            let validatedataSintomiOdierna = Utils.checkDateInterval(this.state.datiSanitari.dataSintomi, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataSintomi) {
                return "Messages.DataSintomi"
            } else if (!validatedataSintomiOdierna) {
                return "Messages.DataSintomiOdierna"
            }
        }
        if (this.state.datiSanitari.dataRicovero) {
            let validatedataRicovero = Utils.checkDateInterval(this.state.datiSanitari.dataRicovero, "31/12/1899");
            let validatedataRicoveroOdierna = Utils.checkDateInterval(this.state.datiSanitari.dataRicovero, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataRicovero) {
                return "Messages.DataRicovero"
            } else if (!validatedataRicoveroOdierna) {
                return "Messages.DataRicoveroOdierna"
            }
        }
        if (this.state.datiSanitari.dataDiagnosi) {
            let validatedataDiagnosi = Utils.checkDateInterval(this.state.datiSanitari.dataDiagnosi, "31/12/1899");
            let validatedataDiagnosiOdierna = Utils.checkDateInterval(this.state.datiSanitari.dataDiagnosi, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataDiagnosi) {
                return "Messages.DataDiagnosi"
            } else if (!validatedataDiagnosiOdierna) {
                return "Messages.DataDiagnosiOdierna"
            }
        }
        if (this.state.datiSanitari.dataEmoscopica) {
            let validatedataEmoscopica = Utils.checkDateInterval(this.state.datiSanitari.dataEmoscopica, "31/12/1899");
            let validatedataEmoscopicaOdierna = Utils.checkDateInterval(this.state.datiSanitari.dataEmoscopica, Utils.transformTimeStampForFrontend(Utils.getTodayDateTimestamp()));

            if (validatedataEmoscopica) {
                return "Messages.DataEmoscopica"
            } else if (!validatedataEmoscopicaOdierna) {
                return "Messages.DataEmoscopicaOdierna"
            }
        }

        return ""

    }

    createOggettoBE() {
        let datiSanitari = JSON.parse(JSON.stringify(this.state.datiSanitari))
        let datiSanitariBe = Utils.removeEmptyValueFromObject(datiSanitari)
        return Utils.removeFieldFromObject(datiSanitariBe, "corretto")
    }

    controlloDati() {
        let datiSanitari = this.state.datiSanitari
        datiSanitari.corretto = []

        if (!datiSanitari.dataSintomi || (datiSanitari.dataSintomi && Utils.isDateInValid(Utils.transformDateForBackend(datiSanitari.dataSintomi), "-")))
            datiSanitari.corretto[0] = "Campo \"Data inizio sintomi\" mancante o errato";

            this.setState({datiSanitari: datiSanitari})

    }

    riceviValore(field, event) {
        let datiSanitari = this.state.datiSanitari
        if (field.currentTarget) {
            datiSanitari[field.currentTarget.id] = field.currentTarget.value
        } else {
            datiSanitari[field] = event.target.value
        }
        this.setState({datiSanitari: datiSanitari})

        this.controlloDati()
    }

    render() {

        const {t} = this.props;

        const sezione1 = (
            <div>
                <div>
                    <h6>{t("SchedaFlussoSpeciale.Malaria.DatiSanitari.titolo")}</h6>
                    <hr className={stylesWelcome.hr}/>
                </div>
                <div style={{marginTop: "1rem"}}>
                    <div className="container">
                        <div className="row">

                            <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                                <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaFlussoSpeciale.Malaria.DatiSanitari.dataInizio")}
                                    <span className={stylesWelcome.mandatoryColor}>*</span>
                                </p>
                                <Calendar
                                    id={"dataSintomi"}
                                    value={this.state.datiSanitari.dataSintomi}
                                    field={"dataSintomi"}
                                    onChange={this.riceviValore}
                                    errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaFlussoSpeciale.Malaria.DatiSanitari.dataInizio"))}
                                    error={(this.state.datiSanitari.dataSintomi === "" || this.state.datiSanitari.dataSintomi == null) ? false :
                                        Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiSanitari.dataSintomi), "-")
                                    }
                                >
                                </Calendar>
                            </div>

                            <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                                <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                    {t("SchedaFlussoSpeciale.Malaria.DatiSanitari.dataRicovero")}
                                </p>
                                <Calendar
                                    id={"dataRicovero"}
                                    value={this.state.datiSanitari.dataRicovero}
                                    field={"dataRicovero"}
                                    onChange={this.riceviValore}
                                    errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaFlussoSpeciale.Malaria.DatiSanitari.dataRicovero"))}
                                    error={(this.state.datiSanitari.dataRicovero === "" || this.state.datiSanitari.dataRicovero == null) ? false :
                                        Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiSanitari.dataRicovero), "-")
                                    }
                                >
                                </Calendar>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );

        const sezione2 = (

            <div style={{marginTop: "1rem"}}>
                <div className="container">
                    <div className="row">

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.Malaria.DatiSanitari.ospedale")}
                            </p>
                            <Input id={"struttura"}
                                onChange={this.riceviValore}
                                field={"struttura"}
                                value={this.state.datiSanitari.struttura}
                                placeholder={t("SchedaFlussoSpeciale.Malaria.DatiSanitari.ospedale")}
                            />
                        </div>

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.Malaria.DatiSanitari.reparto")}
                            </p>
                            <Input id={"reparto"}
                                   onChange={this.riceviValore}
                                   field={"reparto"}
                                   value={this.state.datiSanitari.reparto}
                                   placeholder={t("SchedaFlussoSpeciale.Malaria.DatiSanitari.reparto")}
                            />
                        </div>
                    </div>
                </div>
            </div>

        );

        const sezione3 = (

            <div style={{marginTop: "1rem"}}>
                <div className="container">
                    <div className="row">

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello2' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.Malaria.DatiSanitari.dataClinica")}
                            </p>
                            <Calendar
                                id={"dataDiagnosi"}
                                value={this.state.datiSanitari.dataDiagnosi}
                                field={"dataDiagnosi"}
                                onChange={this.riceviValore}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaFlussoSpeciale.Malaria.DatiSanitari.dataClinica"))}
                                error={(this.state.datiSanitari.dataDiagnosi === "" || this.state.datiSanitari.dataDiagnosi == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiSanitari.dataDiagnosi), "-")
                                }
                            >
                            </Calendar>
                        </div>

                        <div className={`col-lg-3 ${this.props.segnalazioneCopia.statoValidazione === OggettiUtili.statoValidazioneByLabel.Validata.codice ? 'livello1' : ''}`}>
                            <p style={{color: "#1b7ea9", marginTop: "10px"}}>
                                {t("SchedaFlussoSpeciale.Malaria.DatiSanitari.dataEmoscopica")}
                            </p>
                            <Calendar
                                id={"dataEmoscopica"}
                                value={this.state.datiSanitari.dataEmoscopica}
                                field={"dataEmoscopica"}
                                onChange={this.riceviValore}
                                errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaFlussoSpeciale.Malaria.DatiSanitari.dataEmoscopica"))}
                                error={(this.state.datiSanitari.dataEmoscopica === "" || this.state.datiSanitari.dataEmoscopica == null) ? false :
                                    Utils.isDateInValid(Utils.transformDateForBackend(this.state.datiSanitari.dataEmoscopica), "-")
                                }
                            >
                            </Calendar>
                        </div>

                    </div>
                </div>
            </div>
        );


        return (
            <div>
                {sezione1}
                {sezione2}
                {sezione3}
            </div>

        )
    }

}

export default withTranslation('common')(DatiSanitariMalaria)
